import { Injectable } from '@angular/core';
import { ResourceCRUD, ResourceParams } from 'ng2-resource-rest';

interface IQueryInput {
    id? : string;
}

export interface ICustomerShort {
    id              : number;
    firstname       : string;
    lastname        : string;
    company?        : string;
}

export interface ICustomer extends ICustomerShort {
    email           : string;
    address         : string;
    postOffice      : string;
    zipCode         : string;
    phone           : string;
    allowMarketing  : boolean;
}

@Injectable()
@ResourceParams({
    url: '/api/test'
})

export class Customer extends ResourceCRUD<IQueryInput, ICustomerShort, ICustomer> {
    public static newCustomer() : ICustomer {
        return {
            id              : null,
            firstname       : null,
            lastname        : null,
            company         : null,
            email           : null,
            address         : null,
            postOffice      : null,
            zipCode         : null,
            phone           : null,
            allowMarketing  : true
        };
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/customer.ts